import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography'

import {Card,CardHeader, CardContent,CardActions } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '../Button';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';



/** 
 * BillingAdresscard component.
 * Displays textfields related to adress billing infos 
*/

const styles = theme => ({
    header: {
        background: blue[500],  
    },
    title: {
        color: '#FFF'
    },
    first: {
        marginBottom: 24,
    },
    second: {

    },
    third: {
        marginTop:24, 
        marginBottom:24,
    },
    button: {
        marginRight:14, 
        marginLeft:14, 
        marginBottom:24,
    }
  });

 class BillingAdressCard extends Component {

  render() {

    const {classes} = this.props;

    return (
      <div >
        <Card >
        <CardHeader
            className={classes.header}
            title={
                <span >
                    <Typography 
                        className={classes.title} 
                        variant="h6" >
                            Add billing adress
                    </Typography>
                </span>
            }  
        />
        <CardContent>
            <div className={classes.first} >
                <TextField variant="outlined" label="Adress" fullWidth required
                    InputLabelProps={{disableAnimation:true, shrink:true}}/>
            </div>
            <Grid container direction='row' spacing={16}>
                <Grid item xs>
                    <TextField 
                        variant="outlined" 
                        label="Country" 
                        required 
                        fullWidth
                        select 
                        SelectProps={{ native: true }}
                        InputLabelProps={{disableAnimation:true, shrink:true}}>
                        <option  value="Test-Country">
                            Test Country
                        </option>
                    </TextField>
                </Grid>
                <Grid item xs>
                    <TextField 
                        variant="outlined" 
                        label="State" 
                        required
                        fullWidth
                        select 
                        SelectProps={{ native: true }}
                        InputLabelProps={{disableAnimation:true, shrink:true}}>
                            <option  value="Test-State">
                                Test State
                            </option>
                    </TextField>
                </Grid>
            </Grid>
            <Grid container direction='row' spacing={16} className={classes.third}>
                <Grid item xs={6}>
                    <TextField variant="outlined" label="City" required
                        InputLabelProps={{disableAnimation:true, shrink:true}}/>
                </Grid>
                <Grid item xs={6}>
                    <TextField variant="outlined" label="Zip Code" required
                        InputLabelProps={{disableAnimation:true, shrink:true}}/>
                </Grid>
            </Grid>
          
        </CardContent>
        <CardActions>
            <Button 
                fullWidth 
                size="medium" 
                color="primary" 
                variant="contained" 
                className={classes.button}
                >
                <FormattedMessage id='billingInfo.button.confirm' />
            </Button>
        </CardActions>
      </Card>
      </div>
    )
  }
}

export default withStyles(styles)(BillingAdressCard);



// WEBPACK FOOTER //
// ./src/components/billingInfo/BillingAdressCard.js